import { createSlice } from "@reduxjs/toolkit";
import { Box25, cross, fpGroupState, seriesStore } from "../../extra/createState";
import { SET_ADVANCE_DRAW_SELECT_TIME } from "./gameInfo2dSlice";



export const SelecrSeriesStore = ({ seriesSlice2d }) => seriesSlice2d.SERIES_STORE
export const SelectSeriesPartAll = ({ seriesSlice2d }) => seriesSlice2d.SelectSeriesPartAll
export const SelectSeriesPart = ({ seriesSlice2d }) => seriesSlice2d.SelectSeriesPart
export const SelectActiveSeriesIndex = ({ seriesSlice2d }) => seriesSlice2d.ActiveSeriesIndex
export const SelectActiveSeriesPartIndex = ({ seriesSlice2d }) => seriesSlice2d.ActiveSeriesPartIndex
export const SelectHorizontalInput = ({ seriesSlice2d }) => seriesSlice2d.HORIZONTAL_INPUT
export const SelectVerticalInput = ({ seriesSlice2d }) => seriesSlice2d.VERTICAL_INPUT
export const SelectLastInputChangeRecord = ({ seriesSlice2d }) => seriesSlice2d.LAST_INPUT_CHANGE_RECORD
export const SelectPreviewsActiveSeriesIndex = ({ seriesSlice2d }) => seriesSlice2d.PREVIEWS_ACTIVE_SERIES_DETAIL
export const SelectSeriesType = ({ seriesSlice2d }) => seriesSlice2d.SERIES_TYPE
export const SelectSeriesTypeDisableFlag = ({ seriesSlice2d }) => seriesSlice2d.SERIES_TYPE_DISABLE_FLAG
export const SelectFpGroup = ({ seriesSlice2d }) => seriesSlice2d.FP_GROUP
export const SelectCrossGroup = ({ seriesSlice2d }) => seriesSlice2d.CROSS_GROUP
export const SelectBoxGroup = ({ seriesSlice2d }) => seriesSlice2d.BOX_GROUP
export const SelectResultArray = ({ seriesSlice2d }) => seriesSlice2d.RESULT_ARRAY
export const SelectboxValue = ({seriesSlice2d})=>seriesSlice2d.boxValue
export const SelectIsMulti = ({seriesSlice2d})=>seriesSlice2d.IS_MULTI
// console.log('seriesStore: ', seriesStore);

const seriesSlice2d = createSlice({
    name: "seriesSlice2d",
    initialState: {
        SERIES_STORE: seriesStore,
        LOTTARY_GAME_INFO: null,
        SelectSeriesPartAll: false, // select All(10,30,50) series checkbox
        SelectSeriesPart: new Array(10).fill(false), // select 10,30,50 series checkbox
        IS_MULTI: false,
        ActiveSeriesIndex: 0, //inedx of active series, if check allseries than last check series index set
        ActiveSeriesPartIndex: 0, // inedx of active Part series, (border index set)
        HORIZONTAL_INPUT: new Array(10).fill(), //HORIGENTLE line input 
        VERTICAL_INPUT: new Array(10).fill(), //VERTICAL line input ,
        LAST_INPUT_CHANGE_RECORD: { activeSeriesIndex: null, activeSeriesPartIndex: null, input: null }, // last record change
        PREVIEWS_ACTIVE_SERIES_DETAIL: { lastSeriesIndex:null, lastSeriesPartIndex:null,isActiveSeriesName:false }, // store series index active
        SERIES_TYPE : 'All',
        SERIES_TYPE_DISABLE_FLAG : false,
        FP_GROUP : fpGroupState,
        CROSS_GROUP : cross,
        BOX_GROUP : Box25,
        RESULT_ARRAY : [],
        boxValue : new Array(4).fill() //box25 value
    },

    reducers: {
        SET_SERIES_STORE: (state, { payload }) => { state.SERIES_STORE = [...payload] },
        SET_LOTTARY_GAME_INFO: (state, { payload }) => { state.LOTTARY_GAME_INFO = payload },
        SET_SERIES_PART_ALL: (state, { payload }) => { state.SelectSeriesPartAll = payload },
        SET_SERIES_PART_CHECKED: (state, { payload }) => { state.SelectSeriesPart = [...payload] },
        SET_IS_MULTI: (state, { payload }) => { state.IS_MULTI = payload },
        SET_ACTIVE_SERIES_INDEX: (state, { payload }) => { state.ActiveSeriesIndex = payload },
        SET_ACTIVE_SERIES_PART_INDEX: (state, { payload }) => { state.ActiveSeriesPartIndex = payload },
        SET_HORIZONTAL_INPUT: (state, { payload }) => { state.HORIZONTAL_INPUT = [...payload] },
        SET_VERTICAL_INPUT: (state, { payload }) => { state.VERTICAL_INPUT = [...payload] },
        SET_LAST_INPUT_CHANGE_RECORD: (state, { payload }) => { state.LAST_INPUT_CHANGE_RECORD = { ...payload } },
        SET_PREVIEWS_ACTIVE_SERIES_DETAIL: (state, { payload }) => { state.PREVIEWS_ACTIVE_SERIES_DETAIL = { ...payload } },
        SET_SERIES_TYPE : (state,{payload}) => {state.SERIES_TYPE = payload},
        SET_SERIES_TYPE_DISABLE_FLAG : (state,{payload}) => {state.SERIES_TYPE_DISABLE_FLAG = payload},
        SET_RESULT_ARRAY : (state,{payload}) =>{state.RESULT_ARRAY = [...payload]},
        // reset
        RESET_SLICE_STATE : (state,{payload})=>{
            state.SERIES_STORE.forEach((series)=>{
                series.AllSeriesPartName.forEach((partName)=>{
                    partName.active = false
                })
          
                series.seriesAllfield.forEach((fields)=>{
                    fields.forEach(field=>{
          
                        field.resetValue()
                    })
                    
                })
          })
          state.SERIES_STORE = [...state.SERIES_STORE]
          state.ActiveSeriesIndex = 0
          state.ActiveSeriesPartIndex = 0
          state.LAST_INPUT_CHANGE_RECORD = { activeSeriesIndex: null, activeSeriesPartIndex: null, input: null }
          state.PREVIEWS_ACTIVE_SERIES_DETAIL= { lastSeriesIndex:null, lastSeriesPartIndex:null,isActiveSeriesName:false }  
          state.SelectSeriesPart = new Array(10).fill(false)
          state.IS_MULTI = false
          state.SERIES_TYPE_DISABLE_FLAG = false
          state.SERIES_TYPE = "All"
          state.HORIZONTAL_INPUT = new Array(10).fill()
          state.VERTICAL_INPUT = new Array(10).fill()
          state.boxValue = new Array(4).fill()
        },
        // 
        setBoxValue :(state,{payload})=>{state.boxValue =[...payload]}
    }
})




export const {
    SET_SERIES_STORE, SET_LOTTARY_GAME_INFO,
    SET_SERIES_PART_ALL, SET_SERIES_PART_CHECKED, SET_IS_MULTI,
    SET_ACTIVE_SERIES_INDEX, SET_ACTIVE_SERIES_PART_INDEX,
    SET_HORIZONTAL_INPUT, SET_VERTICAL_INPUT,
    SET_LAST_INPUT_CHANGE_RECORD, SET_PREVIEWS_ACTIVE_SERIES_DETAIL,
    SET_SERIES_TYPE, SET_SERIES_TYPE_DISABLE_FLAG, SET_RESULT_ARRAY,
    RESET_SLICE_STATE,setBoxValue

} = seriesSlice2d.actions;

export default seriesSlice2d.reducer;